import React, { Component } from 'react';
import { Button, Grid, TextField, Typography, withMobileDialog, withStyles } from "@material-ui/core";
import {injectIntl, intlShape} from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { loginWatcher } from '../../redux/actions/loginactioncreators';
import messages from "../../messages";
import SaveDevice from "./SaveDevice";
import PropTypes from 'prop-types';
import flowStages from "../../flowStages";
import challengeShape from "../../proptypes/challengeShape";
const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  textField: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  error: {
    backgroundColor: "red",
    color: "white",
    minWidth: "100%",
    textAlign: "center",
    padding: "5px"
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  }
});

class MfaTotpCodeEntry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mfaCode: "",
    }
  }

  handleOnChange = event => {
    let newState = this.state;
    newState.mfaCode = event.target.value;
    this.setState(newState);
  }
  handleOnSubmit = () => {
    let newState = this.state;
    newState.loginErrorMessages = [];
    this.setState(newState);
    this.props.loginWatcher(
      {
        flowStage: flowStages.CHALLENGE,
        challengeResponse: {
          session: this.props.challenge.session,
          challengeName: this.props.challenge.challengeName,
          challengeParameters: {
            USERNAME: this.props.challenge.challengeParameters.USER_ID_FOR_SRP,
            SOFTWARE_TOKEN_MFA_CODE: this.state.mfaCode,

          }
        },
        saveDevice: this.props.saveDevice
      }
    )
  }

  render() {
    const { classes } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <main className={classes.layout}>
        <Grid item xs={12}>
          <Typography variant="h6">{formatMessage(messages.mfaEnterCode)}</Typography>
          <Typography>{formatMessage(messages.totpBlurb)}</Typography>
          <TextField
            autoFocus={true}
            className={classes.textField}
            onChange={this.handleOnChange}
            id="mfacode"
            name="mfacode"
            label={formatMessage(messages.multiFactorTotpCodeEntry)}
            fullWidth={true}
          />

          <Grid container justify="flex-start">
            <Grid item xs={12}>
              <SaveDevice />
            </Grid>
          </Grid>
          <Grid container justify="flex-end">
            <Grid item xs={2}>
              <Button
                id="submit"
                name="submit"
                variant="contained" color="primary"
                onClick={this.handleOnSubmit}
              >
                {formatMessage(messages.totpVerifyButton)}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </main>
    )
  }
}

MfaTotpCodeEntry.propTypes = {
  intl:intlShape,
  saveDevice: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  loginWatcher: PropTypes.func.isRequired,
  challenge: challengeShape,
}
const mapStateToProps = state => {
  return {
    loginErrorMessages: state.loginForm.loginErrorMessages,
    challenge: state.loginForm.challenge,
    saveDevice: state.loginForm.saveDevice
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginWatcher
    // add other watcher sagas to this object to map them to props
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withStyles(styles)(withMobileDialog()(MfaTotpCodeEntry))))